/**
 * Base URL for dash-api REST calls.
 *
 * Prefer same-origin `/api` (CRA dev proxy or nginx) when no explicit URL is set.
 * Matches {@link importWikidataEntityToKb} and {@link FIRESTORE_API_BASE}.
 */
export function getAwpApiBase() {
    return (process.env.REACT_APP_AWP_API_BASE || process.env.REACT_APP_AWP_API_URL || '')
        .replace(/\/$/, '');
}
